import {Ease} from "../core/Animatable";
import {texture} from "../core/AssetHelpers";
import {Container} from "../core/Container";
import {Callback} from "../core/Reflection";
import {Sprite} from "../core/Sprite";
import {Location} from "../data/Location";

export class LocationBackground extends Container {

    public readonly backgroundSprite = this.addChild(new Sprite());
    public readonly backgroundNext = this.addChild(new Sprite());
    public readonly backgroundLarge = {x: 0, y: 0, height: 0};

    public setLocation(location: Location) {
        this.backgroundSprite.texture = texture(`background-${location}.png`)!;
        this.backgroundNext.texture = texture(`background-${location}.png`)!;
        this.backgroundNext.x = this.backgroundSprite.x;
        this.backgroundNext.y = this.backgroundSprite.y;
        this.backgroundNext.scaleX = this.backgroundSprite.scaleX;
        this.backgroundNext.scaleY = this.backgroundSprite.scaleY;
        this.backgroundNext.anchor.x = this.backgroundSprite.anchor.x;
        this.backgroundNext.anchor.y = this.backgroundSprite.anchor.y;
        this.backgroundNext.alpha = 0;
    }

    public changeLocation(location: Location, duration: number = 0.4, cb?: Callback) {
        this.backgroundNext.texture = texture(`background-${location}.png`)!;
        this.backgroundNext.alphaTo(1, duration, () => {
            this.setLocation(location);
            if (cb) {
                cb();
            }
        });
    }

    public zoomIn(duration: number = 0, cb?: Callback) {
        if (duration <= 0) {
            this.backgroundSprite.height = this.backgroundLarge.height;
            this.backgroundSprite.scale.x = this.backgroundSprite.scale.y;
            this.backgroundSprite.x = this.backgroundLarge.x;
            this.backgroundSprite.y = this.backgroundLarge.y;
        } else {
            const s = this.backgroundSprite.scale.y * this.backgroundLarge.height / this.backgroundSprite.height;
            this.backgroundSprite.tweenTo(duration, Ease.sineInOut, {
                scaleX: s,
                scaleY: s,
                x: this.backgroundLarge.x,
                y: this.backgroundLarge.y,
                onComplete: cb,
            });
        }
    }

    public zoomOut(duration: number, cb?: Callback) {
        const s = this.backgroundSprite.scale.y * this.backgroundLarge.height / this.backgroundSprite.height;
        this.backgroundSprite.tweenFrom(duration, Ease.sineInOut, {
            scaleX: s,
            scaleY: s,
            x: this.backgroundLarge.x,
            y: this.backgroundLarge.y,
            onComplete: cb,
        });
    }
}
